import { FunctionComponent } from "react";
import ImageSideContainer from "../../../components/ImageSideContainer";
import SignUpForm from "../../../components/SignupForm";
import Label from "../../../components/Label";

const SignUp: FunctionComponent = ({}) => {
  return (
    <>
      <ImageSideContainer>
        <header className="signUp_header">
          <Label tag="h1">Registrarse</Label>
          <Label tag="p" variants="body1">
            Para acceder a nuestro catálogo de productos online complete los
            siguientes datos:
          </Label>
        </header>
        <section>
          <SignUpForm />
        </section>
      </ImageSideContainer>
    </>
  );
};

export default SignUp;
